import {Component, EventEmitter, Input, Output} from '@angular/core';
import {NgClass, NgIf} from "@angular/common";
import {MatIcon} from "@angular/material/icon";

@Component({
  selector: 'app-popin',
  standalone: true,
  imports: [
    NgClass,
    NgIf,
    MatIcon
  ],
  templateUrl: './popin.component.html',
  styleUrl: './popin.component.css'
})
export class PopinComponent {
  @Input() darkmode: boolean = false;
  @Input() scrollable: boolean = false;
  @Input() isCrossAvailable: boolean = false;
  @Output() close = new EventEmitter<void>;

  constructor() { }

  onCrossClick() {
    this.close.emit();
  }
}
